export default {
  zh: {
    yourFriends: '您邀请的好友',
    bought: '购买了',
    devices: '台设备',
    '年付': '年付',
    '季付': '季付',
    '月付': '月付',
    '连续订阅': '月付',
    '12 Months': '年付',
    '3 Months': '季付',
    '1 Month': '月付',
    'Monthly Subscription': '月付',
    plan: '套餐',
    refunded: '，已取消服务。',
    days: '天',
    CNY: '￥',
    USD: '$',
    beAwarded: '您获得奖励。',
    pending: '冻结中',
    paid: '已解冻',
    cancelled: '奖励撤回',
    description: '描述',
    amount: '金额',
    status: '状态',
    type: '类型',
    firstTopup: '首充',
    renew: '续费'
  },
  en: {
    yourFriends: 'Your friend',
    bought: 'have purchased',
    devices: 'device | devices',
    '年付': '12 months',
    '季付': '3 months',
    '月付': '1 month',
    '连续订阅': '1 month',
    '12 Months': '12 months',
    '3 Months': '3 months',
    '1 Month': '1 month',
    'Monthly Subscription': '1 month',
    plan: ' plan ',
    refunded: ', which has been cancelled.',
    days: 'day | days',
    CNY: '￥',
    USD: '$',
    beAwarded: ', you have got a commission reward.',
    pending: 'Pending',
    paid: 'Released',
    cancelled: 'Void',
    description: 'Description',
    amount: 'Amount',
    status: 'Status',
    type: 'Type',
    firstTopup: 'First Top-up',
    renew: 'Renew'
  }
}



// WEBPACK FOOTER //
// ./src/components/commission/rewardRecords/lang.js